module.exports = __webpack_public_path__ + "assets/icons/launch-logo.bf5e65942d70d4eaa3a962dbaba41f56.svg";